import type * as ngRouter from '@uirouter/angularjs';
import * as angular from 'angular';

import { BugsnagHelpers } from '~/lib/bugsnag-helpers';
import { GroupResource } from '@mode/legacy/data-access-model-js';
import { ApiTypes } from '@mode/shared/contract-common';

import {
  EntitledActionState,
  EntitlementSelectOption,
} from '../connection-permissions-access-dropdown/connection-permissions-access-dropdown.component';
import { ConnectionPermissionsService } from '~/modules/org-settings/components/connection/connection-permissions/connection-permissions.service';
import { ConnectionPermissionsListService } from './connection-permissions-list.service';
import { DatasourceEntitlementResource } from '@mode/legacy/data-access-model-js';

class ConnectionPermissionsListController {
  private orgUsername;
  private dataSourceToken;
  private dataSourceCreatorToken: string;
  private shouldShowRemoveAccessAlert: boolean;
  private $resolve: any;

  static $inject = [
    'ConnectionPermissionsService',
    'ConnectionPermissionsListService',
    'ToastService',
    '$window',
    '$stateParams',
    '$rootScope',
    'dataSource',
    'defaultAccessEntitlement',
    'everyoneGroup',
  ];

  constructor(
    private connectionPermissionsService: ConnectionPermissionsService,
    private connectionPermissionsListService: ConnectionPermissionsListService,
    private AlertService,
    private $window: angular.IWindowService,
    $stateParams: ngRouter.StateParams,
    private $rootScope: angular.IRootScopeService,
    private dataSource: any,
    private defaultAccessEntitlement: DatasourceEntitlementResource,
    private everyoneGroup: GroupResource
  ) {
    this.orgUsername = $stateParams.orgUsername;
    this.dataSourceToken = $stateParams.dataSourceToken;
    this.shouldShowRemoveAccessAlert = $stateParams.shouldShowRemoveAccessAlert;
  }

  $onInit() {
    if (this.shouldShowRemoveAccessAlert) {
      this.connectionPermissionsService.alertAccessRemoved();
    }
    this.dataSourceCreatorToken = this.$resolve.dataSourceCreatorToken;
  }

  getDefaultAccessEntitlementAction(): EntitledActionState {
    return (this.defaultAccessEntitlement && this.defaultAccessEntitlement.action) || EntitledActionState.None;
  }

  handleDefaultAccessSelection($option: EntitlementSelectOption): void {
    if ($option.value === EntitledActionState.None) {
      this.destroyDefaultAccessEntitlement();
    } else {
      this.setDefaultAccessEntitlementAction($option.value);
    }
  }

  destroyDefaultAccessEntitlement(): void {
    if (this.defaultAccessEntitlement) {
      this.connectionPermissionsListService
        .destroyEntitlement(this.defaultAccessEntitlement)
        .then(() => this.updateDefaultAccessEntitlement(null))
        .then(() => this.connectionPermissionsService.alertAccessRemoved())
        .catch((e) => {
          BugsnagHelpers.notifySafely(e);
          console.error(e);
        });
    }
  }

  updateDefaultAccessEntitlement(entitlement: any) {
    this.$rootScope.$applyAsync(() => {
      this.defaultAccessEntitlement = entitlement;
    });
  }

  setDefaultAccessEntitlementAction(action: EntitledActionState): void {
    let promise: angular.IPromise<ApiTypes.ModeResource>;

    if (this.defaultAccessEntitlement) {
      promise = this.connectionPermissionsListService.updateEntitlement(this.defaultAccessEntitlement, action);
    } else {
      promise = this.connectionPermissionsListService.createGroupEntitlement(
        this.dataSource._resource,
        this.everyoneGroup.token,
        action
      );
    }

    promise
      .then((entitlement) => this.updateDefaultAccessEntitlement(entitlement))
      .then(() => {
        if (this.defaultAccessEntitlement) {
          return this.connectionPermissionsService.alertAccessUpdated();
        } else {
          return this.connectionPermissionsService.alertAccessGranted();
        }
      })
      .catch((e) => {
        BugsnagHelpers.notifySafely(e);
        console.error(e);
      });
  }
}

export const ConnectionPermissionsListComponent: angular.IComponentOptions = {
  controller: ConnectionPermissionsListController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <div class="tab-section-wrapper">
      <default-access-row
        selected="{{ ctrl.getDefaultAccessEntitlementAction() }}"
        on-select="ctrl.handleDefaultAccessSelection($option)" />
    </div>
    <connection-permissions-browser
      datasource="ctrl.dataSource"
      datasource-token='{{ctrl.dataSourceToken}}'
      datasource-creator-token='{{ctrl.dataSourceCreatorToken}}'
      org-name='{{ctrl.orgUsername}}'
    ></connection-permissions-browser>
  `,
};
